export const style = {
  title: {
    fontSize: 'lg',
    fontWeight: 'bold',
    textAlign: 'center',
    paddingY: 2,
    paddingX: 4,
  },
  button: {
    w: 'full',
    whiteSpace: 'break-spaces',
    textAlign: 'center',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingY: 5,
    rowGap: 7,
  },
  bold: {
    fontWeight: 'bold',
    fontSize: 'lg',
    marginBottom: 5,
  },
  centerText: {
    marginTop: 5,
    textAlign: 'center',
  },
};
